export default __webpack_public_path__ + "static/media/7.46fc5fb0.svg";